type Value = string | number | boolean

var defaults = {
	expire: 30,
	path: '/'
}

function getCookiePart(expireDays: number, path?: string, domain?: string, secure?: boolean) {
	var result = []
	if (typeof expireDays === 'number' && expireDays !== 0 && expireDays === expireDays) {
		var date = new Date()
		date.setTime(date.getTime() + 24 * 60 * 60 * 1000 * expireDays)
		result.push('; expires=' + date.toUTCString())
	}

	result.push(path ? '; path=' + path : '')
	result.push(domain ? '; domain=' + domain : '')
	result.push(secure != null ? '; ' + secure : '')
	return result.join('')
}

function checkStorage() {
	if (!window || !window.localStorage) {
		throw new TypeError('localStorage is undefined')
	}
}

export function getCookie(key: string, raw = false) {
	var cookies = document.cookie ? document.cookie.split('; ') : [], cookie
	for (let i = 0, len = cookies.length; i < len; i++) {
		cookie = cookies[i].split('=')
		if (cookie[0] === encodeURIComponent(key)) {
			return raw ? cookie[1] : decodeURIComponent(cookie[1])
		}
	}
	return null
}

export function getRawCookie(key: string) {
	return getCookie(key, true)
}

export function setCookie(key: string, value: Value, expireDays?: number, path?: string, domain?: string, secure?: boolean, raw = false) {
	expireDays = expireDays == null ? defaults.expire : Number(expireDays)
	path = path || defaults.path
	key = encodeURIComponent(key)
	if (!raw) {
		value = encodeURIComponent(value)
	}
	document.cookie = `${key}=${value}${getCookiePart(expireDays, path, domain, secure)}`
}

export function setRawCookie(key: string, value: Value, expireDays?: number, path?: string, domain?: string, secure?: boolean,) {
	return setCookie(key, value, expireDays, path, domain, secure, true)
}

export function removeCookie(key: string) {
	setCookie(key, '', -30)
}



export function set(key: string, value: any) {
	checkStorage()
	var valueStr : string
	try {
		valueStr = JSON.stringify(value)
	} catch (e) {
		valueStr = value + ''
	}
	return window.localStorage.setItem(key, valueStr)
}

export function get(key : string){
	checkStorage()
	let valueStr =  window.localStorage.getItem(key)
	if(valueStr == null){
		return valueStr
	}else{
		try {
			return JSON.parse(valueStr)
		} catch (e) {
			return valueStr
		}
	}
}

export function remove(key : string){
	checkStorage()
	return window.localStorage.removeItem(key)
}

export function clear(){
	checkStorage()
	return window.localStorage.clear()
}